import React, { useEffect, useState } from "react";
import api, { showAlert } from "../../util/api";

const initialForm = {
    title: "",
    emphasis: "",
    lead: "",
    description: "",
};

const AdminAbout = () => {
    const [form, setForm] = useState(initialForm);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        fetchAbout();
    }, []);

    const fetchAbout = async () => {
        try {
            const response = await api.get("/admin/about");

            const result = await response.data;

            if (result.success && result.data) {
                setForm({
                    title: result.data.title || "",
                    emphasis: result.data.emphasis || "",
                    lead: result.data.lead || "",
                    description: result.data.description || "",
                });
            }
        } catch (error) {
            console.error("Error fetching about:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSaving(true);
        setMessage("");

        try {
            const response = await api.post("/admin/about", form, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const result = await response.data;

            if (response.success  === false) {
                throw new Error(
                    result.message ||
                    "Unable to save information."
                );
            }

            showAlert('success', 'success!', "About information saved successfully.");

            setMessage(
                "About information saved successfully."
            );
        } catch (error) {
            setMessage(error.message);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="admin-page-loading">
                Loading About information...
            </div>
        );
    }

    return (
        <div className="admin-about-page">

            <div className="admin-page-header">

                <div>
                    <span className="admin-page-eyebrow">
                        WEBSITE CONTENT
                    </span>

                    <h1>About</h1>

                    <p>
                        Manage the About section displayed
                        on the public website.
                    </p>
                </div>

            </div>

            <form onSubmit={handleSubmit}>

                <div className="admin-panel">

                    <div className="admin-panel-header">

                        <div>
                            <span>ABOUT SECTION</span>

                            <h2>
                                Leadership & Representation
                            </h2>
                        </div>

                    </div>

                    <div className="admin-form">

                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Main Title
                                </label>

                                <input
                                    type="text"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    placeholder="Leadership rooted in"
                                    required
                                />

                            </div>

                            <div className="admin-form-group">

                                <label>
                                    Emphasis
                                </label>

                                <input
                                    type="text"
                                    name="emphasis"
                                    value={form.emphasis}
                                    onChange={handleChange}
                                    placeholder="representation."
                                />

                            </div>

                        </div>

                        <div className="admin-form-group">

                            <label>
                                Lead Text
                            </label>

                            <textarea
                                name="lead"
                                value={form.lead}
                                onChange={handleChange}
                                rows="4"
                                placeholder="Write the introductory statement..."
                            />

                        </div>

                        <div className="admin-form-group">

                            <label>
                                Description
                            </label>

                            <textarea
                                name="description"
                                value={form.description}
                                onChange={handleChange}
                                rows="7"
                                placeholder="Write a detailed description..."
                            />

                        </div>

                    </div>

                </div>

                {message && (
                    <div className="admin-form-message">
                        {message}
                    </div>
                )}

                <button
                    type="submit"
                    className="admin-primary-button"
                    disabled={saving}
                >
                    {saving
                        ? "Saving..."
                        : "Save Changes"}
                </button>

            </form>

            <div className="admin-panel admin-about-preview">

                <div className="admin-panel-header">

                    <div>
                        <span>LIVE PREVIEW</span>
                        <h2>About Section</h2>
                    </div>

                </div>

                <div className="admin-about-preview-content">

                    <span className="admin-preview-label">
                        ABOUT
                    </span>

                    <h2>
                        {form.title || "Leadership rooted in"}{" "}
                        <em>
                            {form.emphasis ||
                                "representation."}
                        </em>
                    </h2>

                    <p className="admin-preview-lead">
                        {form.lead ||
                            "Your introductory statement will appear here."}
                    </p>

                    <p>
                        {form.description ||
                            "Your detailed description will appear here."}
                    </p>

                </div>

            </div>

        </div>
    );
};

export default AdminAbout;